








































import {
  computed, defineComponent, reactive, ref,
} from '@vue/composition-api';
import { useMutation } from '@vue/apollo-composable';
import { useFormat, useRouter } from 'vivat';

import absenceLog from '@/table/setting/absenceLog';

import updateDriver from '@/gql/driver/updateDriver.gql';

const CommonPanelWithDriverAbsenceLog = defineComponent({
  props: {
    absenceLogs: { default: () => [] },
  },
  setup(props, { emit }) {
    const { route } = useRouter();
    const NOW = useFormat.date().computerShortDate();
    const NEXTDAY = useFormat.date(useFormat.date().dayjs.add(1, 'day')).computerShortDate();
    const form = reactive({
      reason: 'LEAVE',
      date: {
        from: NEXTDAY,
        to: NOW,
      },
    });

    const modal = ref(null);
    const refetchQueries = ['getDrivers', 'getDriver', 'getDriverForSelectModal'];
    const createAbsenceLogMutation = useMutation(updateDriver, () => ({
      variables: {
        id: route.value.params.id,
        input: {
          absenceLogs: {
            create: [{
              reason: form.reason,
              leaveUntil: form.date.to,
              effectiveDate: form.date.from,
            }],
          },
        },
      },
      refetchQueries,
    }));
    const pendingEditId = ref(-1);
    const updateAbsenceLogMutation = useMutation(updateDriver, () => ({
      variables: {
        id: route.value.params.id,
        input: {
          absenceLogs: {
            create: [{
              reason: form.reason,
              leaveUntil: form.date.to,
              effectiveDate: form.date.from,
            }],
          },
        },
      },
      refetchQueries,
    }));
    createAbsenceLogMutation.onDone(() => {
      (modal.value as any).close();
    });
    updateAbsenceLogMutation.onDone(() => {
      (modal.value as any).close();
    });

    const computedMutation = computed(() => {
      if (pendingEditId.value > -1) return updateAbsenceLogMutation;
      return createAbsenceLogMutation;
    });

    return {
      modal,
      form,
      computedMutation,
      absenceLog,
    };
  },
});

export default CommonPanelWithDriverAbsenceLog;
